import { AccountInfo, RedirectRequest } from '@azure/msal-browser';
import { msalInstance } from './instance';
import { silentRequest } from './requests';

export const getTokens = (
	account: AccountInfo
): Promise<void | { idToken: string; accessToken: string }> => {
	const request: RedirectRequest = {
		...silentRequest,
		account: account,
		redirectUri: window.location.origin
	};
	const response = msalInstance
		.acquireTokenSilent(request)
		.then(async response => {
			return {
				idToken: response.idToken,
				accessToken: response.accessToken
			};
		})
		.catch(async error => {
			console.error('acquireTokenSilent:Error', error);
			await msalInstance.acquireTokenRedirect(request).catch(error => {
				console.error('acquireTokenRedirect:Error', error);
				throw error;
			});
		});
	return response;
};

const getAccessToken = async (): Promise<string | null> => {
	const account = msalInstance.getActiveAccount();
	if (!account) return null;

	const tokens = await getTokens(account);
	if (!tokens) return null;

	return tokens.accessToken;
};

export const authService = {
	getAccessToken
};

export const logoutAccount = async (): Promise<void> => {
	const account = msalInstance.getActiveAccount();
	if (account) {
		await msalInstance.logoutRedirect();
	}
};

export const getInitials = (profile: AccountInfo | null) => {
	let initials = '';
	if (profile && profile.idTokenClaims) {
		const firstName = (profile.idTokenClaims['given_name'] ?? '') as string;
		const lastName = (profile.idTokenClaims['family_name'] ?? '') as string;
		const firstInitial = firstName.length > 0 ? firstName[0] : '';
		const lastInitial = lastName.length > 0 ? lastName[0] : '';
		initials = `${firstInitial}${lastInitial}`;
	}
	return initials;
};
